<template>
    <div id="ag-grid-demo">

        <vx-card>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Merchant</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <vue-simple-suggest pattern="\w+" v-model="model" :list="getList" :max-suggestions="1000"
                        :min-length="0" :debounce="200" :filter-by-query="false" :prevent-submit="true" :controls="{
                            selectionUp: [38, 33],
                            selectionDown: [40, 34],
                            select: [13, 36],
                            hideList: [27, 35]
                        }" :mode="mode" :nullable-select="true" ref="suggestComponent"
                        placeholder="Search information..." value-attribute="id" display-attribute="text"
                        @select="onSuggestSelect">
                        <div class="g">
                            <input id="merchant-search" type="text" placeholder="Select merchant">
                        </div>

                        <template slot="misc-item-above" slot-scope="{ suggestions, query }">
                            <div class="misc-item">
                                <span>You're searching for '{{ query }}'.</span>
                            </div>

                            <template v-if="suggestions.length > 0">
                                <div class="misc-item">
                                    <span>{{ suggestions.length }} suggestions are shown...</span>
                                </div>
                                <hr>
                            </template>

                            <div class="misc-item" v-else-if="!loading">
                                <span>No results</span>
                            </div>
                        </template>

                        <div slot="suggestion-item" slot-scope="scope" :title="scope.suggestion.description">
                            <div class="text">
                                <span v-html="boldenSuggestion(scope)"></span>
                            </div>
                        </div>

                        <div class="misc-item" slot="misc-item-below" slot-scope="{}" v-if="loading">
                            <span>Loading...</span>
                        </div>
                    </vue-simple-suggest>
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Device</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <v-select id="cbo-device" v-model="filter_device" placeholder="Select device" :options="device_list">
                    </v-select>
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Device Status</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <v-select id="cbo-device" v-model="filterStatus" placeholder="Select status" :options="statusList">
                    </v-select>
                </div>
            </div>

            <!-- Button -->
            <div class="vx-row">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>&nbsp;</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button id="btn-filter" icon-pack="feather" icon="icon-search" v-on:click="fetchData(1, 20)"
                        class="mr-3 mb-2 float-left">Filter</vs-button>
                    <vs-button id="btn-reset" icon-pack="feather" icon="icon-refresh-cw" color="warning"
                        v-on:click="resetSearch()" class="mr-3 mb-2 float-left">Reset</vs-button>
                    <vs-button id="btn-export-csv" color="success" icon-pack="feather" icon="icon-download"
                        class="mr-3 mb-2 float-left" @click="exportCSV()">Export to CSV</vs-button>
                    <vs-button color="dark" id="btn-refresh" icon-pack="feather" icon="icon-target"
                        v-on:click="fetchData(1, limit)" class="mr-3 mb-2 float-left">Refresh</vs-button>
                </div>
            </div>
        </vx-card>

        <!-- Show total online - offline -->
        <div class="vx-row h-100">
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-base">
                <vx-card>
                    <div class="flex justify-between flex-row-reverse items-center">
                        <span class="p-1 inline-flex rounded-full feather-icon select-none relative text-danger"
                            style="background: rgba(var(--vs-danger),0.15);">
                            <vs-avatar color="danger" icon="close" />
                        </span>
                        <div class="truncate">
                            <h2 class="mb-1 font-bold">{{ totalOfflinePercentage }}%</h2>
                            <span>{{ totalOffline }} Offline device</span>
                        </div>
                    </div>
                </vx-card>
            </div>

            <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-base">
                <vx-card>
                    <div class="flex justify-between flex-row-reverse items-center">
                        <span class="p-1 inline-flex rounded-full feather-icon select-none relative text-success"
                            style="background: rgba(var(--vs-success),0.15);">
                            <vs-avatar color="success" icon="verified_user" />
                        </span>
                        <div class="truncate">
                            <h2 class="mb-1 font-bold">{{ totalOnlinePercentage }}%</h2>
                            <span>{{ totalOnline }} Online device</span>
                        </div>
                    </div>
                </vx-card>
            </div>

            <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-base">
                <vx-card>
                    <div class="flex justify-between flex-row-reverse items-center">
                        <span class="p-1 inline-flex rounded-full feather-icon select-none relative text-primary"
                            style="background: rgba(var(--vs-primary),0.15);">
                            <vs-avatar color="primary" icon="devices" />
                        </span>
                        <div class="truncate">
                            <h2 class="mb-1 font-bold">{{ allDevice }}</h2>
                            <span>Device</span>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>

        <div class="vx-col md:w-4/4 w-full mb-base">
            <vs-alert v-if="isRefresh" icon="info">
                Notes: Halaman ini akan refresh otomatis setiap {{ refreshTime }}
            </vs-alert>
            <vs-alert active="true" icon="info" v-if="displayNote" class="mt-2">
                Notes: Device akan dinyatakan offline setelah pengiriman last hearbeat > {{ lastMaxHeartBeatTime }}
            </vs-alert>
        </div>
        <vx-card>
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">
                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit
                                > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="fetchData(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <div class="box">
                        <p>Auto Refresh</p>
                        <div :class="{ 'isRefresh': isRefresh }" class="toggle_container">
                            <ToggleButton id="event_handle" @change="triggerRefresh" v-model="isRefresh" />
                        </div>
                    </div>
                </div>

                <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->

            </div>
            <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="dataTrx" rowSelection="multiple"
                colResizeDefault="shift" :animateRows="true" :floatingFilter="true" :pagination="true"
                :paginationPageSize="limit" :suppressPaginationPanel="true" :enableCellTextSelection="true"
                :floatingFiltersHeight="floatingFiltersHeight" @sortChanged="sortChanged"></ag-grid-vue>
            <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPageTable" />
        </vx-card>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { url } from "@/configs/apiUrl";
import Axios from "@/global/AxiosCall";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import StatusDeviceAgGridComponent from "../../../components/cell-render-component/device-monitoring/StatusDeviceAgGridComponent";
import CapacityDeviceAgGridComponent from "../../../components/cell-render-component/device-monitoring/CapacityDeviceAgGridComponent";
import ActionTableAgGridComponent from "../../../components/cell-render-component/device-monitoring/DetailGridComponent";
import InitSamStatusAgGridComponent from "../../../components/cell-render-component/device-monitoring/InitSamStatusAgGridComponent";
import RamUsageDeviceAgGridComponent from "../../../components/cell-render-component/device-monitoring/RamUsageDeviceAgGridComponent";
import CpuUsageDeviceAgGridComponent from "../../../components/cell-render-component/device-monitoring/CpuUsageDeviceAgGridComponent";
import ToggleButton from "../../../components/cell-render-component/device-monitoring/ToggleButton";
import vSelect from 'vue-select'
import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css'
import XLSX from "xlsx"
import moment from 'moment'

export default {
    name: "DeviceMonitoring",
    components: {
        AgGridVue,
        VueSimpleSuggest,
        'v-select': vSelect,
        ToggleButton,
    },
    data() {
        return {
            isRefresh: false,
            refreshTime: '',
            filterStatus: '',
            statusList: [
                { id: 0, label: "ALL" },
                { id: 1, label: "ONLINE" },
                { id: 2, label: "OFFLINE" },
            ],
            displayNote: false,
            lastMaxHeartBeatTime: '',
            chosen: '',
            selected: null,
            model: null,
            mode: 'input',
            loading: false,
            log: [],
            urlx: null,
            interval: null,
            sortListColumn: '',
            sortListType: '',
            floatingFiltersHeight: 0,
            currentPageTable: 1,
            currentPage: 1,
            isMerchantUser: false,
            filterDevice: 'All Device',
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 10,
            gridApi: null,
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: true,
            },
            columnDefs: [
                {
                    headerName: "No",
                    field: "no",
                    width: 80
                },
                {
                    headerName: "Status",
                    field: "device_is_online",
                    width: 175,
                    pinned: 'left',
                    cellRendererFramework: StatusDeviceAgGridComponent
                },
                {
                    headerName: "Last Heartbeat",
                    field: "insert_timestamp",
                    width: 250
                },
                {
                    headerName: "Device Capacity",
                    field: "channel_module_status_str",
                    width: 250,
                    sortable: true,
                    cellRendererFramework: CapacityDeviceAgGridComponent
                },
                {
                    headerName: "Device Ram Usage",
                    field: "channel_module_status_str",
                    width: 250,
                    sortable: true,
                    cellRendererFramework: RamUsageDeviceAgGridComponent
                },
                {
                    headerName: "Device CPU Usage",
                    field: "channel_module_status_str",
                    width: 250,
                    sortable: true,
                    cellRendererFramework: CpuUsageDeviceAgGridComponent
                },
                {
                    headerName: "Device Name",
                    field: "device_name",
                    width: 350,
                    sortable: true,
                    cellRenderer: this.nullColumnRenderer
                },
                {
                    headerName: "Serial Number",
                    field: "serial_number",
                    width: 400,
                    editable: true,
                    sortable: true,
                    cellRenderer: this.nullColumnRenderer
                },
                {
                    headerName: "Device Type",
                    field: "device_type",
                    sortable: true,
                    width: 350,
                    cellRenderer: this.nullColumnRenderer
                },
                {
                    headerName: "Device Code",
                    field: "device_code",
                    sortable: true,
                    width: 250,
                    cellRenderer: this.nullColumnRenderer
                },

                {
                    headerName: "Merchant",
                    sortable: true,
                    field: "merchant_name",
                    width: 250
                },
                {
                    headerName: "SAM Status",
                    field: "channel_module_status_str",
                    cellClass: "cell-wrap-text",
                    autoHeight: true,
                    width: 300,
                    sortable: true,
                    hide: false,
                },
                {
                    headerName: "",
                    field: "channel_module_status_str",
                    cellClass: "cell-wrap-text",
                    autoHeight: true,
                    width: 80,
                    sortable: true,
                    cellRendererFramework: InitSamStatusAgGridComponent
                },
                {
                    headerName: "Actions",
                    field: "_id",
                    filter: false,
                    width: 150,
                    cellRendererFramework: ActionTableAgGridComponent
                }
            ],
            dataTrx: [],
            dataCount: 0,
            totalPage: 0,
            page: 1,
            limit: 20,
            totalData: 0,
            totalOnline: 0,
            allDevice: 0,
            totalOnlinePercentage: 0,
            totalOffline: 0,
            totalOfflinePercentage: 0,
            merchant_list: [],
            device_list: [],
            dataExport: [],
            filter_merchant: '',
            filter_device: '',
        };
    },
    // created: function () {
    //     this.refreshTime = this.secToTime(process.env.VUE_APP_INTERVAL_DEVICE_TIME)
    //     const time_interval = process.env.VUE_APP_INTERVAL_DEVICE_TIME * 1000 == 0 ? 600000 : process.env.VUE_APP_INTERVAL_DEVICE_TIME * 1000;
    //     this.interval = setInterval(function () {
    //         this.fetchData(this.page, this.limit);
    //     }.bind(this), time_interval); 
    // },
    watch: {
        selected: function (val) {
            let merchantidquery = ""
            this.filter_device = ''
            if (val !== null) {
                if (typeof val.merchant_id !== "undefined") {
                    merchantidquery = "?merchant_id=" + val.merchant_id
                }
            }

            Axios.Get(url.svd.device.combo + merchantidquery).then(resp => {
                this.device_list = []
                if (typeof resp.data !== 'undefined')
                    for (let data of resp.data) {
                        data.label = data.name + ' - ' + data.code + ' - ' + data.merchant_full_name
                        this.device_list.push(data)
                    }
            })
        },
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 6;
                this.gridOptions.columnApi.setColumnPinned("Channel", null);
            } else this.gridOptions.columnApi.setColumnPinned("Channel", "left");
        },
        currentPageTable: function (val) {
            this.page = val;
            if (val > 1) {
                this.fetchData(val, this.limit)
            } else {
                this.fetchData(val, this.limit)
            }
        },
    },
    methods: {
        triggerRefresh(val) {
            this.isRefresh = val;
            if (val) {
                let duration = 60
                this.refreshTime = this.secToTime(duration)
                let time_interval = duration * 1000 == 0 ? 600000 : duration * 1000;
                this.interval = setInterval(function () {
                    this.fetchData(this.page, this.limit);
                }.bind(this), time_interval);
            } else {
                window.clearInterval(this.interval)
            }
        },
        sortChanged() {
            let sortList = this.gridApi.getSortModel()

            this.sortListColumn = (sortList.length > 0) ? sortList[0].colId : ''
            this.sortListType = (sortList.length > 0) ? sortList[0].sort : ''

            this.fetchData(this.page, this.limit)
        },
        nullColumnRenderer(params) {
            if (params.value === null)
                return '-'
            else
                return params.value
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val);
        },
        resetSearch() {
            document.getElementById("merchant-search").value = ""
            this.model = null
            this.selected = null
            this.filter_device = ""
            this.page = 1
            this.limit = 20
            this.fetchData(1, 20)
            this.displayNote = false
            this.maxLastHeartBeatTime = ''
        },

        fetchData(page, limit) {
            this.page = page
            this.limit = limit
            let newPage = page;
            if (this.dataCount != 0) {
                let totalPages = Math.ceil(this.dataCount / limit);
                if (page > totalPages) {
                    newPage = totalPages;
                }
            }
            newPage;

            this.openLoading()

            let newUrl = ""
            let code = ""
            let getMerchant = ""
            newUrl = url.device_monitoring.list + "?page=" + page + "&limit=" + limit

            if (this.sortListColumn !== '' && this.sortListType !== '') {
                newUrl += "&orderby=" + this.sortListColumn + "&sortby=" + this.sortListType
            }

            if (this.filterStatus !== '' && this.filterStatus.label !== 'ALL' && this.filterStatus !== null && this.filterStatus !== undefined) {
                newUrl += "&status=" + this.filterStatus.label.toLowerCase();
            }

            // check if one device is selected
            if (this.filter_device !== "" && this.filter_device !== null) {
                newUrl += "&device=true"
                code += this.filter_device.code
                this.processFetchData(newUrl, code, limit, page)
            } else {
                newUrl += "&merchant=true"
                //none selected 
                if (this.selected == null && this.filter_device === "") {
                    getMerchant = url.svd.merchant.list_by_parent_id
                } else if (this.selected != null) {
                    // if select all merchant 
                    if (this.selected.code === "select_all" && this.filter_device === "") {
                        getMerchant = url.svd.merchant.list_by_parent_id
                    }
                }


                //check if merchant is selected  
                if (this.selected !== "" && this.selected !== null && this.selected.code !== "select_all" &&
                    (this.filter_device === "" || this.filter_device === null)) {
                    getMerchant = url.svd.merchant.list_by_parent_id + "/" + this.selected.merchant_id
                }

                // get all merchant code 
                Axios.Get(getMerchant)
                    .then(resp => {
                        if (resp.code === 200) {
                            for (let data of resp.data) {
                                if (data.code !== "") code += data.code + ","
                            }
                            this.processFetchData(newUrl, code, limit, page)
                        }
                    })
            }
        },

        processFetchData(newUrl, code, limit, page) {
            code = code.replace(/,\s*$/, "")
            newUrl += "&code=" + code

            Axios.Get(newUrl)
                .then(resp => {
                    if (this.device_list.length > 0) {
                        this.$vs.loading.close()
                        this.dataTrx = [];
                        this.dataCount = 0
                        this.totalPage = 0
                        let maxLastHeartBeatTime = resp.data.device_max_last_heartbeat_time.split(" ")
                        this.displayNote = true
                        this.lastMaxHeartBeatTime = this.secToTime(maxLastHeartBeatTime[0])

                        if (resp.data.data.length != 0) {
                            this.totalData = parseInt(resp.data.total)
                            this.allDevice = parseInt(resp.data.all_device)
                            let no = 1;
                            for (let data of resp.data.data) {
                                data.no = ((this.page - 1) * this.limit) + no;
                                let channel_module_status_str = ""
                                let channel_module_status_array = []
                                if (data.hasOwnProperty("channel_module_init_result")) {
                                    let channel_module_init_result = data.channel_module_init_result
                                    if (channel_module_init_result != null && typeof channel_module_init_result === "object") {
                                        if (channel_module_init_result.length > 0) {
                                            for (let i in channel_module_init_result) {
                                                let channel_module_init_result_detail = channel_module_init_result[i]
                                                if (channel_module_init_result_detail != null && channel_module_init_result_detail.hasOwnProperty("channel_name") && channel_module_init_result_detail.hasOwnProperty("channel_status")) {
                                                    channel_module_status_array.push(channel_module_init_result_detail)
                                                    if (channel_module_status_str == "") {
                                                        channel_module_status_str += "- " + channel_module_init_result_detail.channel_name;
                                                    } else {
                                                        channel_module_status_str += "\n- " + channel_module_init_result_detail.channel_name;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }

                                if (data.system_info.hasOwnProperty("total_ram") && data.system_info.hasOwnProperty("free_ram")) {
                                    let free_ram = parseFloat(data.system_info.free_ram)
                                    let total_ram = parseFloat(data.system_info.total_ram)
                                    let used_ram = total_ram - free_ram
                                    let result = 0
                                    if (used_ram >= 0 && total_ram > 0) {
                                        result = (used_ram / total_ram) * 100
                                        data.ram_usage = result.toFixed(2) + "%"
                                    }
                                } else {
                                    data.ram_usage = "N/A"
                                }

                                if (data.system_info.hasOwnProperty("cpuload")) {
                                    if (data.system_info.cpuload !== "N/A") {
                                        let cpu_load = parseFloat(data.system_info.cpuload)
                                        data.cpu_usage = cpu_load.toFixed(2) + "%"
                                    } else {
                                        data.cpu_usage = "N/A"
                                    }
                                } else {
                                    data.cpu_usage = "N/A"
                                }

                                data.channel_module_status_str = channel_module_status_str
                                data.channel_module_status_array = channel_module_status_array

                                this.dataTrx.push(data);
                                no++;
                            }

                            this.dataCount = resp.data.total;
                            this.page = page;
                            if (limit >= this.dataCount) {
                                this.limit = this.dataTrx.length;
                            } else {
                                this.limit = limit;
                            }
                            this.gridApi.paginationSetPageSize(this.limit);
                            this.totalPage = resp.data.lastPage;

                            if (resp.data.lastPage == 1 || resp.data.lastPage == 2 || resp.data.lastPage == 3) {
                                this.maxPageNumbers = 5
                            } else if (resp.data.lastPage == 4 || resp.data.lastPage == 5 || resp.data.lastPage == 6) {
                                this.maxPageNumbers = 7
                            } else if (resp.data.lastPage == 7 || resp.data.lastPage == 8) {
                                this.maxPageNumbers = 8
                            } else {
                                this.maxPageNumbers = 10
                            }

                            if (resp.data.lastPage > 0) {
                                this.currentPageTable = resp.data.page
                            } else {
                                this.currentPageTable = 1
                            }

                            if (this.currentPageTable > resp.data.lastPage) {
                                this.currentPageTable = 1
                            }


                            this.totalOnline = parseInt(resp.data.total_online);
                            this.totalOnlinePercentage = (resp.data.all_device > 0) ? ((resp.data.total_online / resp.data.all_device) * 100).toFixed(2) : 0
                            this.totalOffline = parseInt(resp.data.total_offline);
                            this.totalOfflinePercentage = (resp.data.all_device > 0) ? (100 - this.totalOnlinePercentage).toFixed(2) : 0

                        } else {
                            this.totalData = parseInt(resp.data.total)
                            this.allDevice = parseInt(resp.data.all_device)
                            this.totalOnline = parseInt(resp.data.total_online)
                            this.totalOnlinePercentage = (resp.data.all_device > 0) ? ((resp.data.total_online / resp.data.all_device) * 100).toFixed(2) : 0
                            this.totalOffline = parseInt(resp.data.total_offline)
                            this.totalOfflinePercentage = (resp.data.all_device > 0) ? (100 - this.totalOnlinePercentage).toFixed(2) : 0

                        }
                    } else {
                        this.$vs.loading.close()
                        this.dataTrx = [];
                        this.dataCount = 0
                        this.totalPage = 0
                        this.totalOnline = 0
                        this.totalOffline = 0
                        this.totalOnlinePercentage = 0
                        this.totalOfflinePercentage = 0
                    }
                })
                .catch(e => {
                    this.totalOnline = 0
                    this.totalOffline = 0
                    this.totalOnlinePercentage = 0
                    this.totalOfflinePercentage = 0
                    this.$vs.loading.close()
                    console.log(e);
                });
        },

        openLoading() {
            this.$vs.loading({
                type: "default"
            });
        },
        readableBytes(bytes) {
            if (bytes > 0) {
                let i = Math.floor(Math.log(bytes) / Math.log(1024)),
                    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[i];
            } else {
                return "Unknown"
            }

        },
        updateDeviceList(event) {
            let merchantidquery = ""

            this.filter_device = ''

            if (event !== null) merchantidquery = "?merchant_id=" + event.id

            Axios.Get(url.svd.device.combo + merchantidquery).then(resp => {
                this.device_list = []
                if (typeof resp.data !== 'undefined')
                    for (let data of resp.data) {
                        data.label = data.name + ' - ' + data.code + ' - ' + data.merchant_full_name
                        data.name = data.name
                        this.device_list.push(data)
                    }
            })
        },
        boldenSuggestion(scope) {
            if (!scope) return scope;
            if (scope.query == '') {
                this.selected = null
            }
            const { suggestion, query } = scope;
            let result = this.$refs.suggestComponent.displayProperty(suggestion);
            if (!query) return result;
            const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [''];
            return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'), '$1<b>$2</b>$3');
        },
        getList() {
            let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant;
            let merchantid = ((merchant.id !== undefined) ? merchant.id : ((merchant.parent_id !== undefined) ? merchant.parent_id : ""))
            let url = this.urlx.svd.merchant.list_by_parent_id + "/" + merchantid
            if (this.model !== null) url += "?search_merchant=" + this.model

            return new Promise((resolve, reject) => {
                Axios.Get(url).then(response => {
                    if (response.code !== 200) {
                        reject()
                    }
                    let result = []
                    let i = 1
                    result.push({
                        id: i,
                        name: "Select All",
                        text: " - Select All",
                        code: "select_all"
                    })
                    for (let data of response.data) {
                        data.merchant_id = data.id
                        data.id = i + 1
                        let depth = "- "
                        data.name = depth.repeat(data.depth) + data.full_name
                        data.text = depth.repeat(data.depth) + data.full_name
                        data.code = data.code
                        i++
                        if (data.depth < 4) {
                            result.push(data)
                        }
                    }

                    resolve(result)
                }).catch(e => {
                    this.loading = false
                    reject(e)
                })
            })
        },
        onSuggestSelect(suggest) {
            this.selected = suggest
        },
        secToTime(sec) {
            let minutes = (sec / 60);
            let hours = (sec / (60 * 60));
            let days = (sec / (60 * 60 * 24));
            if (sec < 60) return sec + " detik";
            else if (minutes < 60) return minutes + " menit";
            else if (hours < 24) return hours + " jam";
            else return days + " hari"
        },
        exportCSV() {

            this.openLoading()

            let newUrl = ""
            let code = ""
            let getMerchant = ""
            newUrl = url.device_monitoring.list + "?page=1&limit=999999999"

            if (this.sortListColumn !== '' && this.sortListType !== '') {
                newUrl += "&orderby=" + this.sortListColumn + "&sortby=" + this.sortListType
            }

            if (this.filterStatus !== '' && this.filterStatus.label !== 'ALL' && this.filterStatus !== null && this.filterStatus !== undefined) {
                newUrl += "&status=" + this.filterStatus.label.toLowerCase();
            }

            // check if one device is selected
            if (this.filter_device !== "" && this.filter_device !== null) {
                newUrl += "&device=true"
                code += this.filter_device.code
                this.ProcessExportCSV(newUrl, code)
            } else {
                newUrl += "&merchant=true"
                //none selected 
                if (this.selected == null && this.filter_device === "") {
                    getMerchant = url.svd.merchant.list_by_parent_id
                } else if (this.selected != null) {
                    // if select all merchant 
                    if (this.selected.code === "select_all" && this.filter_device === "") {
                        getMerchant = url.svd.merchant.list_by_parent_id
                    }
                }


                //check if merchant is selected  
                if (this.selected !== "" && this.selected !== null && this.selected.code !== "select_all" &&
                    (this.filter_device === "" || this.filter_device === null)) {
                    getMerchant = url.svd.merchant.list_by_parent_id + "/" + this.selected.merchant_id
                }

                // get all merchant code 
                Axios.Get(getMerchant)
                    .then(resp => {
                        if (resp.code === 200) {
                            for (let data of resp.data) {
                                if (data.code !== "") code += data.code + ","
                            }
                            this.ProcessExportCSV(newUrl, code)
                        }
                    })
            }
        },
        ProcessExportCSV(newUrl, code) {
            code = code.replace(/,\s*$/, "")
            newUrl += "&code=" + code

            Axios.Get(newUrl)
                .then(resp => {
                    this.$vs.loading.close()
                    this.dataExport = [];
                    if (resp.data.data.length != 0) {
                        this.totalData = parseInt(resp.data.total)
                        let no = 1;
                        for (let data of resp.data.data) {
                            data.no = ((this.page - 1) * this.limit) + no;
                            // data.online_status = data.device_is_online ? "<span class='text-success'><b>online</b></span>" : "<span class='text-danger'><b>offline</b></span>"
                            let channel_module_status_str = ""
                            if (data.hasOwnProperty("channel_module_init_result")) {
                                let channel_module_init_result = data.channel_module_init_result
                                if (channel_module_init_result != null && typeof channel_module_init_result === "object") {
                                    if (channel_module_init_result.length > 0) {
                                        for (let i in channel_module_init_result) {
                                            let channel_module_init_result_detail = channel_module_init_result[i]
                                            if (channel_module_init_result_detail != null && channel_module_init_result_detail.hasOwnProperty("channel_name") && channel_module_init_result_detail.hasOwnProperty("channel_status")) {
                                                if (channel_module_status_str == "") {
                                                    channel_module_status_str += "" + channel_module_init_result_detail.channel_name;
                                                } else {
                                                    channel_module_status_str += " - " + channel_module_init_result_detail.channel_name;
                                                }
                                            }
                                        }
                                    }
                                }

                            }
                            if (data.hasOwnProperty("system_info")) {
                                if (data.system_info.hasOwnProperty("used_disk") && data.system_info.hasOwnProperty("total_disk")) {
                                    let used_disk = parseFloat(data.system_info.used_disk)
                                    let total_disk = parseFloat(data.system_info.total_disk)
                                    let result = 0
                                    if (used_disk >= 0 && total_disk > 0) {
                                        result = (used_disk / total_disk) * 100
                                        data.capacity = result + "%"
                                    }
                                } else {
                                    data.capacity = "N/A"
                                }

                                if (data.system_info.hasOwnProperty("total_ram") && data.system_info.hasOwnProperty("free_ram")) {
                                    let free_ram = parseFloat(data.system_info.free_ram)
                                    let total_ram = parseFloat(data.system_info.total_ram)
                                    let used_ram = total_ram - free_ram
                                    let result = 0
                                    if (used_ram >= 0 && total_ram > 0) {
                                        result = (used_ram / total_ram) * 100
                                        data.ram_usage = result.toFixed(2) + "%"
                                        data.ram_used = this.readableBytes(used_ram)
                                        data.total_ram = this.readableBytes(total_ram)
                                    }
                                } else {
                                    data.ram_usage = "N/A"
                                }

                                if (data.system_info.hasOwnProperty("cpuload")) {
                                    if (data.system_info.cpuload !== "N/A") {
                                        let cpu_load = parseFloat(data.system_info.cpuload)
                                        data.cpu_usage = cpu_load.toFixed(2) + "%"
                                    } else {
                                        data.cpu_usage = "N/A"
                                    }
                                } else {
                                    data.cpu_usage = "N/A"
                                }

                                if (data.system_info.hasOwnProperty('cpu_one_minute')) {
                                    data.cpu_one_minute = data.system_info.cpu_one_minute
                                } else {
                                    data.cpu_one_minute = ""
                                }
                            } else {
                                data.capacity = "N/A"
                                data.ram_usage = "N/A"
                                data.cpu_usage = "N/A"
                                data.cpu_one_minute = ""
                            }

                            let lastHeartBeaat = moment(data.insert_timestamp).format("YYYY-MM-DD HH:mm:ss")
                            this.dataExport.push({
                                NO: data.no,
                                "DEVICE NAME": data.device_name,
                                "DEVICE CODE": data.device_code,
                                "DEVICE TYPE": data.device_type,
                                "SERIAL NUMBER": data.serial_number,
                                "DEVICE CAPACITY": data.capacity,
                                "LAST HEARTBEAT": lastHeartBeaat,
                                "MERCHANT": data.merchant_name,
                                "SAM STATUS": channel_module_status_str,
                                "STATUS": (data.device_is_online == true) ? "Online" : "Offline",
                                "RAM USAGE": data.ram_usage + ` (${data.ram_used}/${data.total_ram})`,
                                "CPU USAGE": data.cpu_usage,
                                "CPU LOAD": data.cpu_one_minute,
                                "LAST LOGIN": data.last_login
                            });
                            no++
                        }



                        let maxLastHeartBeatTime = resp.data.device_max_last_heartbeat_time.split(" ")
                        this.lastMaxHeartBeatTime = this.secToTime(maxLastHeartBeatTime[0])

                        let ws = XLSX.utils.json_to_sheet([], { skipHeader: true });
                        XLSX.utils.sheet_add_json(ws, [{ Header: `Dokumen diunduh pada tanggal ${moment().format("DD-MM-YYYY HH:mm:ss")}` }], { skipHeader: true, origin: "A1" });
                        XLSX.utils.sheet_add_json(ws, [{ Header: `Notes: Device akan dinyatakan offline setelah pengiriman last hearbeat > ${this.lastMaxHeartBeatTime}` }], { skipHeader: true, origin: "A2" });
                        XLSX.utils.sheet_add_json(ws, this.dataExport, { skipHeader: false, origin: "A3" });


                        let exportDataCSV = XLSX.utils.sheet_to_csv(ws)
                        const url = window.URL.createObjectURL(new Blob([exportDataCSV]));
                        const link = document.createElement('a');
                        link.href = url;
                        let file_name = `device-monitoring_${moment().format("DD-MM-YYYY HHmmss")}.csv`
                        link.setAttribute('download', file_name);
                        document.body.appendChild(link);
                        link.click()
                        link.remove()


                    }
                })
                .catch(e => {
                    console.log(e);
                });
        },
    },
    destroyed: function () {
        clearInterval(this.interval)
    },
    mounted() {
        this.urlx = url
        this.gridApi = this.gridOptions.api;

        this.gridOptions.getRowStyle = function (params) {
            if (params.node.rowIndex % 2 === 0) {
                return { background: '#f9f9f9' }
            }
        }
        this.gridOptions.rowHeight = 54;

        this.gridOptions.headerHeight = 15
        this.gridOptions.groupHeaderHeight = 75
        this.gridOptions.pivotGroupHeaderHeight = 50
        this.gridOptions.pivotHeaderHeight = 100

        let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant;

        let merchantidquery = ""

        let merchantid = ((merchant.id !== undefined) ? merchant.id : ((merchant.parent_id !== undefined) ? merchant.parent_id : ""))

        if (merchantid !== "") merchantidquery = "?merchant_id=" + merchantid

        this.$root.$on("detail-from-ActionTableAgGridComponent-DeviceMonitoring", (data) => {
            this.$router.push({ name: "DeviceMonitoringDetail", query: { id: data } })
        });

        Axios.Get(url.svd.device.combo + merchantidquery).then(resp => {
            this.device_list = []
            if (typeof resp.data !== 'undefined')
                this.device_list.push({
                    label: "Select All",
                    name: "Select All",
                    text: "Select All",
                    code: "select_all"
                })
            for (let data of resp.data) {
                data.label = data.name + ' - ' + data.code + ' - ' + data.merchant_full_name
                this.device_list.push(data)
            }
        })

        if (this.$route.params.data) {
            let { page, limit, status } = this.$route.params.data
            if (status == "offline") {
                this.filterStatus = { id: 2, label: "OFFLINE" };
            } else {
                this.filterStatus = { id: 1, label: "ONLINE" };
            }
            this.fetchData(page, limit)
        }
    }
}
</script>

<style>
/* .ag-pivot-off {
      height: 50px;
      min-height: 50px;
      background: #f2f2f2;
    } */
.vdp-datepicker input {
    padding: .7rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: #626262;
    width: 100%
}

.flatpickr-input {
    padding: .7rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: #626262;
    width: 100%;
}

.vue-simple-suggest.designed .suggestions {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    top: calc(100% + 5px);
    border-radius: 3px;
    border: 1px solid #aaa;
    background-color: #fff;
    opacity: 1;
    z-index: 1000;
    overflow: scroll;
    height: 300px;
}

.cell-wrap-text {
    white-space: pre-wrap !important;
}

.box {
    text-align: center;
    margin-bottom: 30px;
}

.toggle_container {
    margin: 0px auto;
    background: #f5f5f500;
    width: 120px;
    padding: 10px 0;
    border-radius: 30px;
    transition: all .25s;
}

.toggle_container.active {
    background: #f5f5f500;
}
</style>